import eyeIcon from "../../../../assets/images/eye.svg";
import deleteIcon from "../../../../assets/images/trash.svg";
import { getDate } from "../../../../helpers/helperFunction";


const FestvaliColumnDefDefaultFnC = (navigateCallback, onDeleteBUBtnClick) => [
  {
    accessorKey: "action",
    header: "Action",
    cell: ({ row }) => {
      const festivalRowData = row.original;
      // console.log("festivalRowData=======>",festivalRowData)

      return (
        <div className="d-flex clays-sm">
          <button
            class="icon-clay"
            onClick={() => navigateCallback(festivalRowData._id, "view")}
          >
            <span class="inner-clay color-black">
              <img src={eyeIcon} alt="Edit" />
            </span>
          </button>
          <button
            className="icon-clay delete"
            onClick={() => onDeleteBUBtnClick(festivalRowData._id, "delete")}
          >
            <img src={deleteIcon} alt="Delete" />
          </button>
        </div>
      );
    },
  },
  {
    accessorKey: "name",
    header: "Festival Name",
  },
  {
    accessorKey: "startDate",
    header: "Festival Start Date",
    cell: ({ row }) => getDate(row.original.startDate),
  },
  {
    accessorKey: "endDate",
    header: "Festival End Date",
    cell: ({ row }) => getDate(row.original.endDate),
  },
  {
    accessorKey: "description",
    // header: t('OrdersTableText.orderDate'),
    header: "Festival Details",
    // cell: lastNameCellFn
  },
  // {
  //   accessorKey: "isAllowedInSubscription",
  //   header: "Availability of Subscriptions",
  // },
  // {
  //   accessorKey: "image",
  //   header: "Cover Image",
  // },
];
export { FestvaliColumnDefDefaultFnC };
